{
	"title": "Sport entries",
	"common": {
		"loadFailed": "The entries could not be loaded",
		"tryAgain": "Try again"
	},
	"phase": {
		"EOI": "Expression of interest",
		"EBN": "Entry by number",
		"SHORTLIST": "Shortlist",
		"what": {
			"SHORTLIST": "The names of your athletes, per event."
		}
	},
	"state": {
		"NOT_STARTED": "Not started",
		"OPEN": "In progress",
		"FINAL": "Submitted",
		"REOPENED": "Reopened",
		"hint": {
			"NOT_STARTED": "Nothing has been saved for this phase yet.",
			"OPEN": "Saved, not yet submitted. You can still change it.",
			"FINAL": "Submitted as final. Locked for the NOC; only a Super Admin can reopen it.",
			"REOPENED": "Reopened by a Super Admin. Change it and submit again."
		}
	},
	"window": {
		"closesAt": "Closes {{at}}",
		"opensAt": "Opens {{at}}",
		"closedAt": "Closed {{at}}",
		"open": "Open",
		"upcoming": "Upcoming",
		"closed": "Closed",
		"closedTitle": "This phase is closed",
		"closedBody": "Entries can only be changed while the host's window is open. What you saved stays as it is.",
		"notOpenYet": "This phase opens {{at}}. Until then the page is read-only.",
		"adminNote": "Outside the window NOCs cannot change their entries. As an admin you still can."
	},
	"strip": {
		"label": "Entry steps"
	},
	"page": {
		"subtitle": "{{org}} · Sport entries",
		"pickOrg": "Choose a NOC",
		"pickTitle": "Choose a NOC",
		"pickHint": "Pick the NOC whose entries you want to see.",
		"noOrgTitle": "No NOC to enter for",
		"noOrgHint": "Your login is not linked to a NOC that can make sport entries. Ask your administrator.",
		"back": "All NOCs",
		"onBehalf": "You are editing on behalf of {{org}}. Every change is recorded under your name.",
		"readOnly": "You can view these entries but not change them.",
		"csv": "Export CSV",
		"csvName": "entries-{{phase}}.csv"
	},
	"final": {
		"stamp": "{{at}}",
		"stampBy": "{{at}} by {{name}}",
		"locked": "Your entries are locked. Ask the host if something must change.",
		"adminEdit": "Locked for the NOC. As an admin you can still change it."
	},
	"eoi": {
		"heading": "Sports",
		"officials": "Officials",
		"gold": "Gold",
		"silver": "Silver",
		"bronze": "Bronze",
		"valueLabel": "{{field}} for {{sport}}",
		"noSportsTitle": "No sports for these Games",
		"noSportsHint": "The host has not set up any sports yet.",
		"tiles": {
			"sports": "Sports",
			"athletes": "Est. athletes",
			"mw": "{{m}} men · {{w}} women",
			"officials": "Est. officials",
			"medals": "Expected medals",
			"events": "Events picked"
		},
		"search": "Find a sport",
		"filterLabel": "Show",
		"filter": {
			"all": "All",
			"selected": "Picked",
			"unselected": "Not picked"
		},
		"noMatch": "No sport matches “{{q}}”",
		"showAll": "Show all sports",
		"emptyTitle": "No sports picked yet",
		"emptyHint": "Tick a sport to add it to your expression of interest.",
		"tileAdd": "Add {{sport}}",
		"tileRemove": "Remove {{sport}}",
		"toggleHint": "Tick a sport to add it. Open it to pick events and add estimates. Every number is optional.",
		"undo": "Undo",
		"men": "Men",
		"women": "Women",
		"groupMedals": "Medals you aim for",
		"done": "Done",
		"ebnNote_one": "{{n}} event of this sport is already entered in Entry by number.",
		"ebnNote_other": "{{n}} events of this sport are already entered in Entry by number.",
		"menAthletes": "Athletes (men)",
		"womenAthletes": "Athletes (women)",
		"bulkLabel": "Select sports",
		"selectAll": "Select all",
		"selectAllHint": "Adds every sport shown",
		"deselectAll": "Deselect all",
		"deselectAllHint": "Removes every sport shown",
		"bulkDeselected_one": "{{n}} sport deselected",
		"bulkDeselected_other": "{{n}} sports deselected",
		"openSport": "Open {{sport}}: events and estimates",
		"interestedIn": "Interested in {{sport}}",
		"eventsCount_one": "{{n}} event",
		"eventsCount_other": "{{n}} events",
		"eventsPicked_one": "{{picked}} of {{n}} event",
		"eventsPicked_other": "{{picked}} of {{n}} events",
		"allEvents": "All events",
		"noEstimate": "No estimates yet",
		"athletesCount_one": "{{n}} athlete",
		"athletesCount_other": "{{n}} athletes",
		"panel": {
			"subtitle_one": "{{n}} event",
			"subtitle_other": "{{n}} events",
			"interested": "Interested in this sport",
			"interestedOn": "In your expression of interest",
			"interestedOff": "Not in your expression of interest yet. Picking an event or entering a number adds it.",
			"saveNote": "Changes stay on the page until you save.",
			"estimates": "Estimates (optional)",
			"estimatesHint": "Leave a box blank if you don't know yet. Blank is not the same as 0.",
			"medalsFromEvents": "the sum of your events below",
			"events": "Events",
			"selectAllEvents": "Select all events",
			"deselectAllEvents": "Deselect all events",
			"allEventsHint": "No events picked means you are interested in all events of this sport.",
			"noEvents": "This sport has no events yet."
		},
		"ev": {
			"entries": "Expected entries",
			"teams": "Expected teams",
			"entriesLabel": "Expected entries in {{event}}",
			"medalLabel": "Expected {{medal}} in {{event}}",
			"less": "One less: {{field}}, {{event}}",
			"more": "One more: {{field}}, {{event}}",
			"entriesMax_one": "The quota is {{n}} entry per NOC.",
			"entriesMax_other": "The quota is {{n}} entries per NOC."
		},
		"cap": {
			"none": "Not a medal event: no medals to expect.",
			"entries_one": "At most {{n}} medal: one entry can win only one.",
			"entries_other": "At most {{n}} medals: each of your {{n}} entries can win one.",
			"quota_one": "At most {{n}} medal: the quota is {{n}} entry per NOC.",
			"quota_other": "At most {{n}} medals: the quota is {{n}} entries per NOC.",
			"offered": "This event awards {{g}} gold, {{s}} silver, {{b}} bronze.",
			"team": "A team counts as one entry.",
			"clamped": "Lowered to fit the limit.",
			"reached": "Limit reached for this event"
		}
	},
	"remove": {
		"title_one": "Remove this sport from your entries?",
		"title_other": "Remove these sports from your entries?",
		"lead_one": "You are removing {{n}} sport: {{sports}}.",
		"lead_other": "You are removing {{n}} sports: {{sports}}.",
		"cascade_one": "This also deletes {{n}} event entry already made in Entry by number.",
		"cascade_other": "This also deletes {{n}} event entries already made in Entry by number.",
		"confirm": "Remove and save",
		"cancel": "Cancel"
	},
	"ebn": {
		"needsEoiTitle": "Submit your expression of interest first",
		"needsEoiHint": "Entry by number opens once your expression of interest is submitted as final.",
		"goEoi": "Go to Expression of interest",
		"noSportsTitle": "No sports for these Games",
		"noSportsHint": "The host has not set up any sports yet.",
		"numberLabel": "Entries in {{event}}",
		"decrease": "One less in {{event}}",
		"increase": "One more in {{event}}",
		"teamsUnit_one": "team",
		"teamsUnit_other": "teams",
		"unsaved_one": "{{n}} unsaved change",
		"unsaved_other": "{{n}} unsaved changes",
		"noEvents": "This sport has no events yet.",
		"tiles": {
			"sports": "Sports",
			"events": "Events entered",
			"entries": "Entries",
			"implied": "Implied athletes",
			"estimate": "EOI estimate {{n}}"
		},
		"teamsCount_one": "{{n}} team",
		"teamsCount_other": "{{n}} teams",
		"sheet": {
			"legend": "A yellow edge marks events you picked in your expression of interest",
			"fromEoi": "From your expression of interest",
			"fromEoiEmpty": "No sports in your expression of interest. Enter numbers under Other sports.",
			"others": "Other sports",
			"othersHint": "Not in your expression of interest. Entering a number adds the sport to it when you save.",
			"othersEntered_one": "{{n}} with entries",
			"othersEntered_other": "{{n}} with entries",
			"eoiLine": "Your EOI estimate: {{m}} men, {{w}} women, {{o}} officials"
		},
		"willAdd": "Will be added to your EOI",
		"willAddHint": "Saving adds {{sport}} to your expression of interest, with no estimates.",
		"addedToEoi_one": "Saved. {{list}} was added to your expression of interest.",
		"addedToEoi_other": "Saved. {{list}} were added to your expression of interest.",
		"enterAll": "Enter all",
		"enterAllHint": "Puts 1 in every empty event",
		"clearSport": "Clear sport",
		"maxMedals_one": "max {{n}} medal",
		"maxMedals_other": "max {{n}} medals",
		"youEstimated_one": "In your EOI · you estimated {{n}}",
		"youEstimated_other": "In your EOI · you estimated {{n}}",
		"inYourEoi": "In your EOI",
		"inactiveSport": "This sport is no longer active.",
		"useEoi": "Use EOI numbers",
		"useEoiHint_one": "Fills {{n}} empty event with your EOI number",
		"useEoiHint_other": "Fills {{n}} empty events with your EOI numbers",
		"search": "Find an event or sport",
		"noMatch": "No event matches “{{q}}”.",
		"athletesCount_one": "{{n}} athlete",
		"athletesCount_other": "{{n}} athletes",
		"teamsAthletes_one": "{{teams}} team · {{n}} athletes",
		"teamsAthletes_other": "{{teams}} teams · {{n}} athletes"
	},
	"warning": {
		"title": "Check before you submit",
		"sportWithoutEvents_one": "{{n}} sport has no event entered: {{list}}",
		"sportWithoutEvents_other": "{{n}} sports have no event entered: {{list}}",
		"aboveEstimate_one": "{{sport}}, {{event}}: {{needed}} athlete needed, {{estimated}} estimated",
		"aboveEstimate_other": "{{sport}}, {{event}}: {{needed}} athletes needed, {{estimated}} estimated",
		"belowEstimate_one": "{{sport}}: {{implied}} athlete implied, {{estimated}} estimated",
		"belowEstimate_other": "{{sport}}: {{implied}} athletes implied, {{estimated}} estimated",
		"none": "Nothing to check. Everything looks consistent.",
		"aboveInline_one": "Needs {{needed}} athlete; your EOI estimated {{estimated}}.",
		"aboveInline_other": "Needs {{needed}} athletes; your EOI estimated {{estimated}}.",
		"belowInline_one": "These entries use {{implied}} athlete; your EOI estimated {{estimated}}.",
		"belowInline_other": "These entries use {{implied}} athletes; your EOI estimated {{estimated}}.",
		"withoutInline": "No event entered for this sport yet.",
		"notInEoi": "{{sport}} will be added to your expression of interest",
		"withoutEvents": "{{sport}}: no event entered"
	},
	"bar": {
		"label": "Save and submit",
		"unsaved_one": "{{n}} unsaved change",
		"unsaved_other": "{{n}} unsaved changes",
		"discard": "Discard",
		"save": "Save changes",
		"submit": "Review and submit",
		"submitNeeds": "Save at least one sport or entry first",
		"reopen": "Reopen",
		"finalTitle": "Submitted as final",
		"saveReview": "Save and review"
	},
	"reopen": {
		"title": "Reopen {{phase}}",
		"body": "The NOC can change its entries again and must submit them again.",
		"eoiAlso": "Reopening the expression of interest also reopens entry by number.",
		"reason": "Reason",
		"reasonRequired": "Say why it is being reopened.",
		"cancel": "Cancel",
		"confirm": "Reopen",
		"done": "{{phase}} reopened"
	},
	"save": {
		"done": "Saved",
		"removedEntries_one": "Saved. {{n}} event entry in Entry by number was deleted with the removed sports.",
		"removedEntries_other": "Saved. {{n}} event entries in Entry by number were deleted with the removed sports."
	},
	"leave": {
		"title": "Discard your changes?",
		"body_one": "You have {{n}} unsaved change. It will be lost.",
		"body_other": "You have {{n}} unsaved changes. They will be lost.",
		"stay": "Stay",
		"discard": "Discard and leave"
	},
	"overview": {
		"subtitle": "All NOCs",
		"nocs": "NOCs",
		"count_one": "{{n}} NOC",
		"count_other": "{{n}} NOCs",
		"search": "Search NOCs",
		"table": {
			"sports": "Sports",
			"estAthletes": "Est. athletes",
			"medals": "Expected medals",
			"events": "Events",
			"entries": "Entries",
			"implied": "Implied athletes",
			"open": "Open",
			"openLabel": "Open the entries of {{org}}"
		},
		"pagination": {
			"summary": "{{from}}–{{to}} of {{total}}",
			"empty": "No NOCs"
		},
		"empty": {
			"noneTitle": "No NOCs yet",
			"noneHint": "NOCs appear here once responsible organizations of the NOC type exist.",
			"filteredTitle": "No NOC matches",
			"filteredHint": "Try another search or state.",
			"clear": "Clear filters"
		},
		"matrix": {
			"title": "By sport",
			"label": "NOCs by sport",
			"metric": {
				"EOI": "Estimated athletes",
				"EBN": "Entries"
			},
			"noc": "NOC",
			"total": "Total",
			"cellEoi": "{{org}}, {{sport}}: {{m}} men, {{w}} women, {{o}} officials",
			"cellEbn": "{{org}}, {{sport}}: {{events}} events, {{entries}} entries",
			"empty": "Nothing entered yet.",
			"drill": "Open the events of {{sport}}",
			"legendLabel": "What the marks mean",
			"legend": {
				"EOI": "Darker = more estimated athletes",
				"EBN": "Darker = more entries",
				"tick": "Picked, no athlete estimate yet",
				"empty": "Not picked",
				"drill": "Pick a sport's name to see its events below."
			}
		},
		"byEvent": {
			"title": "By event",
			"sport": "Sport",
			"pickSport": "Choose a sport",
			"pickHint": "Pick a sport to see each NOC's entries per event.",
			"event": "Event",
			"total": "Total",
			"empty": "No entries for this sport yet.",
			"cap": "Max {{n}} per NOC"
		},
		"cards": {
			"splitAria": "{{m}} men, {{w}} women",
			"medalsAria": "Expected medals: {{g}} gold, {{s}} silver, {{b}} bronze",
			"notStarted": {
				"EOI": "No expression of interest yet",
				"EBN": "No entry by number yet"
			},
			"submittedAt": "Submitted {{at}}",
			"sort": {
				"name": "Name",
				"state": "Progress",
				"sports": "Sports",
				"athletes": "Estimated athletes",
				"medals": "Expected medals",
				"entries": "Entries"
			},
			"dir": {
				"asc": "Sort ascending",
				"desc": "Sort descending",
				"short": {
					"asc": "Ascending",
					"desc": "Descending"
				}
			}
		},
		"progress": "{{final}} of {{total}} submitted · {{started}} responded"
	},
	"guide": {
		"title": "Entry states",
		"states": "States",
		"window": "Windows",
		"windowNote": "Set by the host per phase, for every NOC or for one.",
		"windowOpen": "NOCs can change entries now.",
		"windowUpcoming": "Not open yet.",
		"windowClosed": "Over. NOCs can no longer change entries."
	},
	"help": {
		"button": "How it works",
		"title": "How sport entries work",
		"steps": {
			"EOI": {
				"title": "Expression of interest",
				"body": "Pick the sports you plan to enter and, if you like, the events and estimates. Every number is optional. Submit when ready."
			},
			"EBN": {
				"title": "Entry by number",
				"body": "For each event, say how many athletes or teams you enter. Every sport is listed: entering one outside your EOI adds it there. The host's maximum per NOC applies."
			},
			"SHORTLIST": {
				"title": "Shortlist",
				"body": "Name the athletes per event. Your entry numbers are shown there next to each event's limit."
			}
		},
		"windows": "Each phase can only be changed while the host's window is open. Submitting locks the phase; only a Super Admin can reopen it.",
		"remove": "Removing a sport from the expression of interest also removes its entries by number."
	},
	"windows": {
		"title": "Entry windows",
		"intro": "When NOCs may fill in and submit their expression of interest and entry by number. Outside every window NOCs cannot change or submit; admins always can.",
		"count_one": "{{n}} window",
		"count_other": "{{n}} windows",
		"add": "Add window",
		"table": {
			"phase": "Phase",
			"games": "Games",
			"organisation": "NOC",
			"allOrganisations": "Every NOC",
			"opens": "Opens",
			"closes": "Closes",
			"status": "Status",
			"editLabel": "Edit the {{phase}} window",
			"deleteLabel": "Delete the {{phase}} window"
		},
		"filters": {
			"games": "Games",
			"phase": "Phase",
			"organisation": "NOC",
			"search": "Search"
		},
		"empty": {
			"noneTitle": "No entry windows yet",
			"noneHint": "Without a window NOCs cannot fill in their entries. Add one per phase.",
			"filteredTitle": "No window matches",
			"filteredHint": "Try another phase.",
			"clear": "Clear filters"
		},
		"pagination": {
			"summary": "{{from}}–{{to}} of {{total}}",
			"empty": "No windows"
		},
		"form": {
			"addTitle": "Add entry window",
			"editTitle": "Edit entry window",
			"description": "NOCs may change and submit this phase between these times.",
			"games": "Games",
			"gamesFixed": "The games of a window can't change. Delete it and add a new one instead.",
			"phase": "Phase",
			"organisation": "NOC",
			"organisationHint": "Leave empty for every NOC. A window for one NOC is added to the general one.",
			"allOrganisations": "Every NOC",
			"opensAt": "Opens",
			"closesAt": "Closes",
			"zoneHint": "Times are in your time zone ({{zone}}).",
			"required": "Required",
			"closesAfterOpens": "Must be after the opening time",
			"save": "Save",
			"add": "Add window",
			"cancel": "Cancel",
			"shortlistHint": "Shortlist: the closing time is the shortlist deadline. Without a shortlist window, NOCs can change their shortlist at any time."
		},
		"toast": {
			"added": "Window added",
			"updated": "Window updated",
			"deleted": "Window deleted",
			"addFailed": "The window could not be added",
			"updateFailed": "The window could not be updated"
		},
		"delete": {
			"title": "Delete this window?",
			"description": "NOCs covered only by this {{phase}} window will no longer be able to change their entries.",
			"confirm": "Delete window",
			"failed": "The window could not be deleted"
		},
		"pickGames": "Choose the Games"
	},
	"shortlist": {
		"declared": "Declared {{n}}",
		"declaredHint": "The number your NOC declared in Entry by number. For information only; the limit above applies."
	},
	"journey": {
		"eoiEdit": "Pick the sports {{org}} plans to enter. Events and estimates are optional.",
		"eoiFinal": "{{org}}'s expression of interest is in. Entry by number is next.",
		"eoiReadOnly": "Here is what {{org}} expressed interest in.",
		"ebnEdit": "Now the numbers: how many athletes or teams {{org}} enters per event.",
		"ebnFinal": "{{org}}'s entries by number are in. Next, register your delegation in Accreditation.",
		"ebnReadOnly": "Here is what {{org}} entered by number.",
		"ebnWaiting": "Entry by number opens once {{org}}'s expression of interest is submitted."
	},
	"stepper": {
		"decrease": "One less: {{field}}",
		"increase": "One more: {{field}}"
	},
	"board": {
		"medalCount": "{{medal}}: {{n}}"
	},
	"poster": {
		"edit": "Change anyway"
	},
	"celebrate": {
		"EOI": {
			"title": "Expression of interest submitted",
			"body": "Nice work. Entry by number is open for you now.",
			"go": "Go to Entry by number"
		},
		"EBN": {
			"title": "Entry by number submitted",
			"body": "Great. Next, register your delegation in Accreditation.",
			"bodyLocked": "Great. Accreditation opens in Sector 2; the organising committee will let you know.",
			"go": "Register New Record"
		},
		"close": "Close"
	},
	"history": {
		"adminOnly": "Admin only",
		"badgeTitle": "Past SEA Games (admin only). {{tier}}: {{g}} gold, {{s}} silver, {{b}} bronze.",
		"tier": {
			"TOP": "Best NOC in this sport",
			"GOLD": "Won gold",
			"MEDAL": "Won medals, no gold",
			"NONE": "Took part, no medal",
			"NO_DATA": "Not held in the last 3 Games"
		},
		"stripLabel": "Past results in {{sport}}",
		"medalledIn_one": "Medalled in {{x}} of {{n}} Games",
		"medalledIn_other": "Medalled in {{x}} of {{n}} Games",
		"rank": "No. {{rank}} by golds",
		"notHeld": "Not held",
		"noTable": "No medal table",
		"noMedal": "No medal",
		"medal": {
			"g_one": "{{n}} gold",
			"g_other": "{{n}} gold",
			"s_one": "{{n}} silver",
			"s_other": "{{n}} silver",
			"b_one": "{{n}} bronze",
			"b_other": "{{n}} bronze"
		},
		"strongTitle": "Historically strong, not picked",
		"strongNone": "Every sport this NOC has won gold in is picked.",
		"chip_one": "{{sport}}, {{n}} gold",
		"chip_other": "{{sport}}, {{n}} golds",
		"chipShow": "Show {{sport}} (does not add it)",
		"more_one": "{{n}} more",
		"more_other": "{{n}} more"
	},
	"analysis": {
		"title": "AI analysis",
		"subtitle": "The declaration against this NOC's results at the last three SEA Games",
		"updated": "Updated {{when}}",
		"updating": "Updating…",
		"analysing": "Analysing the declaration…",
		"nothing": "Nothing stands out against the past results yet.",
		"notInHistory": "There are no past SEA Games results for this organisation, so there is nothing to compare.",
		"down": "The analysis could not be made just now. Try again later.",
		"downWithLast": "The analysis could not be updated just now. This is the last one.",
		"limit": "Today's limit for analyses is reached. Try again tomorrow.",
		"limitWithLast": "Today's limit for analyses is reached. This is the last one; it updates tomorrow.",
		"retry": "Try again",
		"rankFirst": "Best record of any NOC",
		"rank": "No. {{rank}} among NOCs",
		"kind": {
			"STRENGTH": "Strength",
			"ABOVE_HISTORY": "Above history",
			"BELOW_HISTORY": "Below history",
			"NOT_IN_EOI": "Not in EOI",
			"NO_EBN_ENTRIES": "No EBN entry",
			"NO_PAST_MEDAL": "No past medal",
			"OVERALL": "Overall"
		},
		"finding": {
			"STRENGTH_one": "{{noc}} is strong in {{sport}} based on history records: {{gold}} gold, {{silver}} silver and {{bronze}} bronze at {{games}} SEA Games.",
			"STRENGTH_other": "{{noc}} is strong in {{sport}} based on history records: {{gold}} gold, {{silver}} silver and {{bronze}} bronze over {{games}} SEA Games.",
			"ABOVE_HISTORY_GOLD_one": "{{noc}} expects {{expected}} gold in {{sport}}, more than its best of {{history}} at one SEA Games ({{year}}).",
			"ABOVE_HISTORY_GOLD_other": "{{noc}} expects {{expected}} gold in {{sport}}, more than its best of {{history}} at one SEA Games ({{year}}).",
			"ABOVE_HISTORY_MEDALS_one": "{{noc}} expects {{expected}} medal in {{sport}}, more than its best of {{history}} at one SEA Games ({{year}}).",
			"ABOVE_HISTORY_MEDALS_other": "{{noc}} expects {{expected}} medals in {{sport}}, more than its best of {{history}} at one SEA Games ({{year}}).",
			"BELOW_HISTORY_GOLD_one": "{{noc}} expects {{expected}} gold in {{sport}}, fewer than the {{history}} it won at the {{year}} SEA Games.",
			"BELOW_HISTORY_GOLD_other": "{{noc}} expects {{expected}} gold in {{sport}}, fewer than the {{history}} it won at the {{year}} SEA Games.",
			"BELOW_HISTORY_MEDALS_one": "{{noc}} expects {{expected}} medal in {{sport}}, fewer than the {{history}} it won at the {{year}} SEA Games.",
			"BELOW_HISTORY_MEDALS_other": "{{noc}} expects {{expected}} medals in {{sport}}, fewer than the {{history}} it won at the {{year}} SEA Games.",
			"NOT_IN_EOI_one": "{{sport}} is not in {{noc}}'s EOI, though {{noc}} won {{gold}} gold in it at {{games}} SEA Games.",
			"NOT_IN_EOI_other": "{{sport}} is not in {{noc}}'s EOI, though {{noc}} won {{gold}} gold in it over {{games}} SEA Games.",
			"NO_EBN_ENTRIES_one": "{{sport}} is in {{noc}}'s EOI but has no EBN entry yet, though {{noc}} won {{gold}} gold in it at {{games}} SEA Games.",
			"NO_EBN_ENTRIES_other": "{{sport}} is in {{noc}}'s EOI but has no EBN entry yet, though {{noc}} won {{gold}} gold in it over {{games}} SEA Games.",
			"NO_PAST_MEDAL_one": "{{noc}} declared {{sport}}, where it won no medal at the {{games}} SEA Games it was held at.",
			"NO_PAST_MEDAL_other": "{{noc}} declared {{sport}}, where it won no medal at any of the {{games}} SEA Games it was held at.",
			"OVERALL_one": "In {{sports}} sport, {{noc}} expects {{expected}} gold; at the {{year}} SEA Games it won {{history}} gold in all sports.",
			"OVERALL_other": "Across {{sports}} sports, {{noc}} expects {{expected}} gold; at the {{year}} SEA Games it won {{history}} gold in all sports."
		}
	},
	"strength": {
		"switch": {
			"label": "Overview view",
			"table": "NOC table",
			"map": "Strength map"
		},
		"map": {
			"title": "Strength map",
			"mode": {
				"EOI": "Past SEA Games results per sport, with a tick where the NOC picked the sport in its EOI.",
				"EBN": "Past SEA Games results per sport, with the NOC's EBN entries in the sport."
			},
			"noc": "NOC",
			"gaps": "Gaps",
			"scroll": "Strength map, scrolls sideways",
			"sportTitle_one": "{{sport}}: {{n}} gold over the last 3 Games. Show its top nations.",
			"sportTitle_other": "{{sport}}: {{n}} golds over the last 3 Games. Show its top nations.",
			"sportPodium": "Show the top nations in {{sport}}",
			"empty": {
				"all": "This games has no sports yet.",
				"contested": "None of these sports was held in the last 3 Games.",
				"gaps": "No gaps: every NOC has declared the sports it won gold in."
			}
		},
		"show": {
			"label": "Show",
			"all": "All sports",
			"contested": "Held before",
			"gaps": "Gaps only"
		},
		"sportSort": {
			"label": "Sports by",
			"code": "Code",
			"golds": "Past golds"
		},
		"nocSort": {
			"label": "NOCs by",
			"name": "Name",
			"golds": "Past golds"
		},
		"legend": {
			"label": "Legend",
			"tier": {
				"TOP": "Best NOC in the sport",
				"GOLD": "Won gold",
				"MEDAL": "Medals, no gold",
				"NONE": "No medal",
				"NO_DATA": "Not held / no table"
			},
			"picked": {
				"EOI": "In the EOI",
				"EBN": "EBN entries"
			},
			"gap": {
				"EOI": "Won gold, not in the EOI",
				"EBN": "Won gold, no EBN entries"
			}
		},
		"cell": {
			"label": "{{org}}, {{sport}}: {{tier}}. {{state}}",
			"inEoi": "In the EOI.",
			"entries_one": "{{n}} EBN entry.",
			"entries_other": "{{n}} EBN entries.",
			"notPicked": {
				"EOI": "Not in the EOI.",
				"EBN": "No EBN entries."
			},
			"gap": {
				"EOI": "Won gold before, not in the EOI.",
				"EBN": "Won gold before, no EBN entries."
			}
		},
		"nocs": {
			"title": "Where each NOC is strong",
			"line": {
				"EOI_one": "Won gold in {{n}} sport, {{m}} in the EOI",
				"EOI_other": "Won gold in {{n}} sports, {{m}} in the EOI",
				"EBN_one": "Won gold in {{n}} sport, {{m}} with EBN entries",
				"EBN_other": "Won gold in {{n}} sports, {{m}} with EBN entries"
			},
			"noGaps": {
				"EOI": "Every gold sport is in the EOI.",
				"EBN": "Every gold sport has EBN entries."
			},
			"noGold": "No gold in the last 3 Games.",
			"noHistory": "No past SEA Games results for this organisation.",
			"gapsLabel": "Gold sports {{org}} has not declared",
			"chipTitle": "Open {{sport}}"
		},
		"podium": {
			"title": "Top nations",
			"sport": "Pick a sport",
			"golds_one": "{{n}} gold in {{sport}} over the last 3 Games.",
			"golds_other": "{{n}} golds in {{sport}} over the last 3 Games.",
			"notHeld": "{{sport}} was not held in the last 3 Games.",
			"none": "No medal table to rank.",
			"place": "Place {{rank}}"
		},
		"detail": {
			"title": "{{org}} in {{sport}}",
			"gap": {
				"EOI": "{{org}} won gold in this sport before and has not put it in the EOI.",
				"EBN": "{{org}} won gold in this sport before and has no EBN entries in it."
			},
			"declared": "Declared now",
			"notInEoi": "Not in the EOI.",
			"athletes": "Athletes (estimate)",
			"athletesValue": "{{m}} men, {{w}} women",
			"officials": "Officials (estimate)",
			"expected": "Expected medals",
			"ebn": "EBN",
			"ebnValue_one": "{{n}} entry in {{events}} events",
			"ebnValue_other": "{{n}} entries in {{events}} events",
			"ebnNone": "No entries yet",
			"open": {
				"EOI": "Open {{org}}'s EOI",
				"EBN": "Open {{org}}'s EBN"
			}
		}
	},
	"event": {
		"teamOf": "Team of {{n}}",
		"teamRange": "Team of {{min}}–{{max}}",
		"quotaEntries_one": "Up to {{n}} entry",
		"quotaEntries_other": "Up to {{n}} entries",
		"quotaNone": "No quota",
		"quotaHint": "How many athletes or teams each NOC may enter to compete.",
		"mark": {
			"TIME": "{{mark}}",
			"DISTANCE": "{{mark}} m",
			"WEIGHT": "{{mark}} kg",
			"POINTS": "{{mark}} pts",
			"SCORE": "{{mark}}",
			"NONE": "{{mark}}"
		},
		"qualifyingLower": "Qualifying: {{mark}} or under",
		"qualifyingHigher": "Qualifying: {{mark}} or over"
	},
	"review": {
		"title": "Review {{phase}}",
		"lockTitle": "Submitting locks it",
		"lockEoi": "After you submit, your NOC can no longer change its expression of interest. Entry by number opens next. Only a Super Admin can reopen it.",
		"lockEbn": "After you submit, your NOC can no longer change its entries by number. Only a Super Admin can reopen it.",
		"confirmEoi": "I understand this locks my expression of interest.",
		"confirmEbn": "I understand this locks my entries by number.",
		"submit": "Submit as final",
		"back": "Back to editing",
		"cannotSubmit": "This cannot be submitted now. Check the window and that something is saved.",
		"sports": "Sports",
		"noSports": "No sports picked.",
		"noEntries": "No events entered.",
		"sportLine": "Athletes: {{m}} men, {{w}} women · officials: {{o}}",
		"allEvents_one": "All events ({{n}})",
		"allEvents_other": "All events ({{n}})",
		"event": "Event",
		"entries": "Entries",
		"athletes": "Athletes",
		"dashNote": "— means not given.",
		"expandAll": "Expand all",
		"collapseAll": "Collapse all",
		"eventsCount_one": "{{n}} event",
		"eventsCount_other": "{{n}} events",
		"addedTitle_one": "Sport added to your expression of interest",
		"addedTitle_other": "Sports added to your expression of interest"
	}
}
